import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import type {
  Kpi,
  KpiCategory,
} from 'lumen/utils/constants/ri-constant-values';
import kpiCategoryDisplayNameFormatter from 'lumen/utils/revenue-insight/kpi-category-display-name-formatter';

interface HotelAndMarketRevenueInsightFixedKpiHeaderItemSignature {
  Args: {
    changeTab: (kpi: Kpi) => void;
    /**
     * Selected KPI
     */
    kpi: Kpi;
    kpiCategory: KpiCategory;
    /**
     * KPI for this item
     */
    kpiName: Kpi;
    title: string;
    value: string;
  };
}

export default class HotelAndMarketRevenueInsightFixedKpiHeaderItem extends Component<HotelAndMarketRevenueInsightFixedKpiHeaderItemSignature> {
  @service declare intl: Services['intl'];
  @service declare riSelections: Services['ri-selections'];
  @service declare usageAnalytics: Services['usage-analytics'];

  get kpiCategoryDisplayName(): string {
    return kpiCategoryDisplayNameFormatter(
      this.args.kpiCategory,
      this.riSelections,
      this.intl,
    );
  }

  @action
  changeTab(kpiName: Kpi): void {
    this.usageAnalytics.track('KPI Displayed Changed', {
      eventTrigger: 'kpi-picker',
      kpiName,
    });

    this.args.changeTab(kpiName);
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    <div class="header-item">
      <div
        class={{if (eq @kpi @kpiName) "selected"}}
        data-event-id="hotel-revenue-insight-sticky-kpi-select"
        data-event-value={{@kpiName}}
        role="button"
        {{on "click" (fn this.changeTab @kpiName)}}
      >
        <p class="kpi-name text-300--regular">{{@title}}</p>
        <span class="kpi-value text-200--regular">
          <span
            class="highlight mr-100"
          >{{this.kpiCategoryDisplayName}}</span>{{@value}}
        </span>
      </div>
    </div>
  </template>
}
